import { SentryRoutes } from '../../instrument';

import * as Sentry from '@sentry/react';
import { Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { ErrorFallback, LoadingOverlay } from '../components';
import { lazyImport } from '../utils';
import { Path } from './paths';

const { HomePage } = lazyImport(() => import('../pages'), 'HomePage');
const { AggregatedProjectsPage } = lazyImport(
  () => import('../pages'),
  'AggregatedProjectsPage',
);

export const AppRoutes = () => {
  return (
    <ConditionalBoundary>
      <Suspense fallback={<LoadingOverlay />}>
        <SentryRoutes>
          <Route path={`${Path.Home}`}>
            <Route index element={<HomePage />} />
            <Route path=":projectId" element={<HomePage />} />
          </Route>
          <Route
            path={Path.AggregatedProjects}
            element={<AggregatedProjectsPage />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </SentryRoutes>
      </Suspense>
    </ConditionalBoundary>
  );
};

function ConditionalBoundary({ children }: { children: React.ReactNode }) {
  return import.meta.env.DEV ? (
    children
  ) : (
    <Sentry.ErrorBoundary
      fallback={(prompts) => <ErrorFallback {...prompts} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
